<script lang="ts" setup>
import { computed } from "vue";
import { getDisplayDateTime } from "@/modules/common";
import { Story, StoryBook } from "@/types/entity";

const props = defineProps<{
  story: Story | StoryBook;
}>();

const isGenerating = computed(() => {
  return !props.story?.dtComplete && !props.story?.description;
});
</script>
<template>
  <div :class="{ 'opacity-50': isGenerating }" class="flex py-2 h-28 gap-4">
    <div class="h-full aspect-[1/1] relative">
      <BaseImg :media="story.media" ratio="1/1" />
      <div
        v-if="!story.dtPublish || isGenerating"
        class="badge badge-neutral absolute right-1 top-1 badge-sm"
      >
        {{ isGenerating ? $t("story.processing") : $t("story.draft") }}
      </div>
    </div>
    <div class="flex flex-col flex-grow gap-1 h-full overflow-hidden">
      <div class="text-base">
        {{ isGenerating ? $t("story.generatingStory") : story.title }}
      </div>
      <div class="text-base-content/50 text-sm van-multi-ellipsis--l3">
        {{ isGenerating ? $t("story.generateTimeMinutes") : story.description }}
      </div>
      <div v-if="isGenerating" class="text-base-content/50">
        {{ $t("story.generateTime") }} :
        {{ getDisplayDateTime(story.dtCreate!) }}
      </div>
    </div>
  </div>
</template>
